module.exports = __webpack_public_path__ + "static/media/right-chevron.a25b8e4d.svg";